import { Link, useNavigate } from "react-router-dom";
import "./notification.css";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import { useEffect, useState } from "react";
import axios from "axios";
import { NotificationMagasinType } from "../../../Modeles/NotificationModel";

export default function NotificationCommercial() {
  const [notifications, setNotifications] = useState<NotificationMagasinType[]>([]);
  const [loading, setLoading] = useState(true);
  const [popup, setPopup] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState<any>(null);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const commercialId = localStorage.getItem("CommercialId");
        const url = `${process.env.REACT_APP_PHP_APP_URL}/magasins/${commercialId}/notification?role=Commercial`;
        const res = await axios.get(url);
        setNotifications(res.data);
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  const markAsRead = async (id: any) => {
    try {
      const commercialId = localStorage.getItem("CommercialId");
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${commercialId}/notification/${id}`);
    } catch (error) {
      console.error("Erreur lors de la mise à jour de la notification", error);
    }
  };

  const handleClickNotif = (notif: any) => {
    setSelectedNotif(notif);
    setPopup(true);
    // Optimistically mark as read in local state immediately
    if (notif.IsRead !== 1) {
      setNotifications(prev =>
        prev.map(n => n.id === notif.id ? { ...n, IsRead: 1 } : n)
      );
    }
    markAsRead(notif.id);
  };

  const unreadCount = notifications.filter((n: any) => n.IsRead === 0).length;

  const formatDate = (raw: any) => {
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    return d.toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <>
      <NewSidebareCommercial />

      <div className="notifications-page-ncom">
        {/* Header Section */}
        <div className="notifications-header-ncom">
          <div className="header-content-ncom">
            <div className="header-left-ncom">
              <div className="header-icon-ncom">
                <i className="bi bi-bell-fill"></i>
              </div>
              <div className="header-text-ncom">
                <h1 className="header-title-ncom">Notifications</h1>
                <p className="header-subtitle-ncom">
                  Restez informé de toutes les activités
                </p>
              </div>
            </div>
            {unreadCount > 0 && (
              <div className="unread-badge-ncom">
                <span>{unreadCount} non lue{unreadCount > 1 ? "s" : ""}</span>
              </div>
            )}
          </div>
        </div>

        {/* Notifications Container */}
        <div className="notifications-container-ncom">
          {loading ? (
            <div className="loader-container-ncom">
              <div className="spinner-ncom"></div>
              <span className="loader-text-ncom">Chargement des notifications...</span>
            </div>
          ) : notifications && notifications.length > 0 ? (
            <div className="notifications-list-ncom">
              {notifications.map((notif: any, index: number) => (
                <div
                  key={notif.id || index}
                  className={`notification-card-ncom ${notif.IsRead === 1 ? "read-ncom" : "unread-ncom"}`}
                  onClick={() => handleClickNotif(notif)}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {/* Unread Indicator */}
                  {notif.IsRead === 0 && (
                    <div className="unread-indicator-ncom"></div>
                  )}

                  {/* Icon */}
                  <div className={`notification-icon-ncom ${notif.IsRead === 1 ? "read-icon-ncom" : "unread-icon-ncom"}`}>
                    <i className="bi bi-bell-fill"></i>
                  </div>

                  {/* Content */}
                  <div className="notification-content-ncom">
                    <div className="notification-header-row-ncom">
                      <h3 className="notification-title-ncom">
                        {notif.Title}
                      </h3>
                      <span className="notification-date-ncom">
                        {formatDate(notif.Date)}
                      </span>
                    </div>

                    <p className="notification-message-ncom">
                      {notif.Content}
                    </p>

                    {/* Status Badge */}
                    <div className="notification-footer-ncom">
                      <span className={`status-badge-ncom ${notif.IsRead === 1 ? "read-status-ncom" : "unread-status-ncom"}`}>
                        {notif.IsRead === 1 ? (
                          <>
                            <i className="bi bi-check-circle-fill"></i>
                            <span>Déjà lue</span>
                          </>
                        ) : (
                          <>
                            <i className="bi bi-circle-fill"></i>
                            <span>Nouvelle</span>
                          </>
                        )}
                      </span>

                      <div className="arrow-icon-ncom">
                        <i className="bi bi-arrow-right"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-ncom">
              <div className="empty-icon-wrapper-ncom">
                <i className="bi bi-bell-slash"></i>
              </div>
              <h2 className="empty-title-ncom">Aucune notification</h2>
              <p className="empty-text-ncom">
                Nous vous préviendrons dès qu'il y aura du nouveau.
                <br />
                Revenez plus tard pour vérifier vos notifications.
              </p>
            </div>
          )}
        </div>

        {/* Modal Popup */}
        {popup && selectedNotif && (
          <div className="modal-overlay-ncom" onClick={() => setPopup(false)}>
            <div className="modal-card-ncom" onClick={(e) => e.stopPropagation()}>
              {/* Close Button */}
              <button className="modal-close-btn-ncom" onClick={() => setPopup(false)}>
                <i className="bi bi-x-lg"></i>
              </button>

              {/* Success Icon */}
              <div className="modal-icon-wrapper-ncom">
                <div className="modal-icon-ncom">
                  <i className="bi bi-check-lg"></i>
                </div>
              </div>

              {/* Content */}
              <div className="modal-content-ncom">
                <h2 className="modal-title-ncom">{selectedNotif.Title}</h2>
                <p className="modal-message-ncom">{selectedNotif.Content}</p>
                
                  <div className="modal-meta-ncom">
                    <span className="modal-date-ncom">
                      <i className="bi bi-clock"></i>
                      {formatDate(selectedNotif.Date)}
                    </span>
                  </div>
              </div>

              {/* Actions */}
              <div className="modal-actions-ncom">
                {selectedNotif.Url ? (
                  <Link
                    to={selectedNotif.Url}
                    className="modal-btn-ncom primary-ncom"
                    onClick={() => setPopup(false)}
                  >
                    <span>Voir les détails</span>
                    <i className="bi bi-arrow-right"></i>
                  </Link>
                ) : (
                  <button
                    className="modal-btn-ncom primary-ncom"
                    onClick={() => setPopup(false)}
                  >
                    <span>D'accord</span>
                    <i className="bi bi-check-lg"></i>
                  </button>
                )}
                <button
                  className="modal-btn-ncom secondary-ncom"
                  onClick={() => setPopup(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
